<template>
  <div class="row">
    <div class="col-xs-12 text-right up-arrow">
      <span>
        <a v-scroll-to="'#top'" style="cursor: pointer;" class="text-red"><i class="fa fa-chevron-up"></i>&nbsp;&nbsp;nach oben</a>
      </span>
    </div>
  </div>
</template>